import styled, {css} from "styled-components";
import {radii} from "theme/tokens";
import {slideOutMutedInk, slideOutPalette} from "./SlideOutCard.styles";

/**
 * What is the WARNING card's own, on top of the family shell in `SlideOutCard.styles`
 * (kitecorp/transferify-ui#2468): the usage line and the two-part meter. Every colour is the amber
 * accent's, read through {@link slideOutPalette} so the card and its shell can never disagree about
 * which family this is.
 */

const accent = "warning" as const;

export const Count = styled.p`
	margin: 0 0 6px;
	font-size: 11px;
	font-weight: 500;
	font-variant-numeric: tabular-nums;
	color: ${({theme}) => slideOutMutedInk(theme, accent)};
`;

export const Meter = styled.div`
	display: flex;
	height: 5px;
	margin: 0 0 8px;
	border-radius: ${radii.pill};
	background: ${({theme}) => slideOutPalette(theme, accent).track};
	overflow: hidden;
`;

/** The solid fill is what the month has spent; the striped one after it is what this transfer would. */
export const Bar = styled.div<{$percent: number; $pending?: boolean}>`
	height: 100%;
	width: ${({$percent}) => $percent}%;
	background: ${({theme}) => slideOutPalette(theme, accent).action};
	transition: width .5s cubic-bezier(.2, .9, .3, 1);
	${({$pending, theme}) => $pending && css`
		background: repeating-linear-gradient(90deg, ${slideOutPalette(theme, accent).action} 0 4px, transparent 4px 7px);
		opacity: .85;
	`}
	@media (prefers-reduced-motion: reduce) { transition: none; }
`;
